// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sapmain
{
    height:100vh;
    width:100%;
    background-color: #000000;
    display: flex;
    flex-direction: column;
    align-items: center;
   
    color:white;
}
table {
  margin-top: 10px ;
  width: 100%;
  height:150px;
  border-collapse: collapse;
}
th, td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

tr.violated {
  background-color: #eb9c9c;
}
h2, h3 {
  color: #333;
}
.button {
  background-color: #4CAF50; /* Green */
  border: none;
  color: white;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}
.sapcard
{
    height:70%;
    width:40%;
    background-color: white;
    border: 1px solid black;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    color: black;

    margin: auto;
    justify-content: center;
}
.pref_card{
  position: absolute;
  width: 200px;
  height: 200px;
  background-color: white;
  border-radius: 10px;
  color:black;

  margin:20px;
}
.pref_text{
  padding: 2px;
}
.navbar1
{
    width:200px;
    height:8%;
    padding: 20px;
    margin-left: 40px;
    display: flex;
    align-items: center;
    cursor: pointer;
     
    /* background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); */
}

.result_modal{
  position: fixed;
  top:0;
  left:0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
}
.modal-box{
  background-color: #ffffff;
  height: 508px;
  width: 732px;
  margin: auto;
  padding: 10px;
  box-shadow: 2px solid black;
  border-radius: 6px;
  color: black;
}
.download_btn{
  background: transparent;
  width:20px;
  height: 20px;
}
.modal_text{
  /* color: rgb(255, 255, 255); */
  color: black;
  padding: 13px;
  font-size: 18px;
  position: relative;
  margin-left: 10px;
  margin-top: 30px;
}
.close_btn{
  position: absolute;
  color: #f53535;
  font-size: 28px;
  cursor: pointer;
}
.navbar1:hover{
  color: #642bff;
}
.home_link{
  text-decoration: none;
     color:white;
     font-size: 18px;
     margin-left: 4px;
}
.home_link:hover{
  color:#642bff;

}
.sapcard div {
    display: flex;
   margin-bottom: 10px; /* Adding some space between each div */
  }

.APIIN
{
    width:50%;
    height:30px;
    padding-left: 10px;
}
.filein
{
    width:50%;
    height:30px
}

.button-18 {
  align-items: center;
  background-color: #642bff;
  border: 0;
  border-radius: 100px;
  box-sizing: border-box;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  font-family: -apple-system, system-ui, system-ui, "Segoe UI", Roboto, "Helvetica Neue", "Fira Sans", Ubuntu, Oxygen, "Oxygen Sans", Cantarell, "Droid Sans", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Lucida Grande", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 600;
  justify-content: center;
  line-height: 20px;
  max-width: 250px;
  min-height: 40px;
  min-width: 0px;
  overflow: hidden;
  padding: 0px;
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;
  touch-action: manipulation;
  transition: background-color 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s, box-shadow 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s, color 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: middle;
  gap:8px
}

.button-18:hover { 
  background:transparent;
  border: 2px solid #642bff;
  color: black;
}

.button-18:active {
  background: #09223b;
  color: rgb(255, 255, 255, .7);
}

.button-18:disabled { 
  cursor: not-allowed;
  background: rgba(0, 0, 0, .08);
  color: rgba(0, 0, 0, .3);
}
.dimg
{
    width:20px;
    height: 20px;
}
.button-19 {
    align-items: center;
    background-color: #BED754;
    border: 0;
    border-radius: 100px;
    box-sizing: border-box;
    color: #ffffff;
    cursor: pointer;
    display: inline-flex;
    font-family: -apple-system, system-ui, system-ui, "Segoe UI", Roboto, "Helvetica Neue", "Fira Sans", Ubuntu, Oxygen, "Oxygen Sans", Cantarell, "Droid Sans", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Lucida Grande", Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-weight: 600;
    justify-content: center;
    line-height: 20px;
    max-width: 250px;
    min-height: 40px;
    min-width: 0px;
    overflow: hidden;
    padding: 0px;
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;
    touch-action: manipulation;
    transition: background-color 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s, box-shadow 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s, color 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s;
    user-select: none;
    -webkit-user-select: none;
    vertical-align: middle;
    gap:8px;
    margin-top:20px;
  }
  
  .button-19:hover,
  .button-19:focus { 
    background-color: #8ADAB2;
    color: #ffffff;
  }
  
  .button-19:active {
    background: #8ADAB2;
    color: rgb(255, 255, 255, .7);
  }
  
  .button-19:disabled { 
    cursor: not-allowed;
    background: rgba(0, 0, 0, .08);
    color: rgba(0, 0, 0, .3);
  }

  .ii1
  {
    width:100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap:10px
  }

  .sapnavbar
  {
    align-items: center;
  }

 .sapcont{
  display:flex;
  width:100%;
  height:100%;

 }
 .drawer-cont{
 position: absolute;
 right:0;
 top:10;
 margin-right:20px;
 font-size: 30px;
 cursor: pointer;
 }
 label{
  font-size: 14px;
 }
 .drawer{
  width: 17.2%;
  height: 80vh;
  background-color: #642bff;
  position: absolute;
  top: 10;
  right: 0;
  transition: all 0.5s ease-in-out;
  margin-top: 30px;
  border-radius: 6px ;
  margin-right: 20px;
  overflow-y: scroll;
  scrollbar-width: thin;
  
  }
  .close{
  font-size: 30px;
  background-color: #3743e6;
  position: absolute;
  top: 0;
  left: 150px;
  
  }
  .submit_btn{
    padding: 5px 16px;
    background-color: #2ea44f;
    border-radius: 2px ;
    color: white;
    border: none;
    cursor: pointer;
  }
  .submit_btn:hover{
   
    background: #3f9b59;
 

  }
  .checkbox-dropdown > label{
    padding: 4px;
  }
  .checkbox-dropdown > label > input{
    margin-right: 5px;
    
  }
  input[type="checkbox"]{
    
    accent-color: black;
  }

   
  .cancel_btn{
    padding: 5px 16px;
    background-color: #BF3131;
    border: none;
    color: white;
    border-radius: 2px;
    cursor: pointer;
    
  }
  .cancel_btn:hover{
    
    background: #c54a4a;
   

  }
  .dropdown1{
  padding-top: 20px;
  padding: 10px;
  margin-top: 40px;
  
  }
  .dropdown2{
    padding-top: 20px;
  padding: 10px;
  }
  .dropdown3{
    padding-top: 20px;
  padding: 10px;
  }
  .checkbox-dropdown{
  display: flex;
  flex-direction: column;
  padding-left: 10px;
 
  }
  .dropdownArrow{
  display: flex;
  font-size: 30px;
  align-items: center;
  }
  .actionbtns{
   padding: 10px;
   margin-top: 20px;
   display: flex;
   justify-content: space-evenly;
  }

  /*  search bar */
  .search-box {
    position: relative;
    display: inline-block;
    width: 100%;
}

.search-input {
    width: 80%;
    margin-left: 10px;
    margin-top: 10px;
    padding: 6px 20px;
    border: none;
    border-radius: 4px;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
    font-size: 16px;
    transition: all 0.3s ease;
}

.search-input:focus {
    outline: none;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
}

.search-btn {
    position: absolute;
    top: 65%;
    right:30px;
    transform: translateY(-50%);
    border: none;
    background: none;
    padding: 0;
    cursor: pointer;
}

.search-icon {
    width: 24px;
    height: 24px;
    fill: #555;
    transition: fill 0.3s ease;
}

.search-btn:hover .search-icon {
    fill: #333;
}`, "",{"version":3,"sources":["webpack://./src/components/SAP.css"],"names":[],"mappings":"AAAA;;IAEI,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;IAEnB,WAAW;AACf;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB,EAAE,UAAU;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;AACA;;IAEI,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;;IAEZ,YAAY;IACZ,uBAAuB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;;EAEX,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;;IAEI,WAAW;IACX,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,eAAe;;IAEf,yEAAyE;AAC7E;;AAEA;EACE,eAAe;EACf,KAAK;EACL,MAAM;EACN,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,UAAU;EACV,YAAY;AACd;AACA;EACE,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;KAClB,WAAW;KACX,eAAe;KACf,gBAAgB;AACrB;AACA;EACE,aAAa;;AAEf;AACA;IACI,aAAa;GACd,mBAAmB,EAAE,uCAAuC;EAC7D;;AAEF;;IAEI,SAAS;IACT,WAAW;IACX,kBAAkB;AACtB;AACA;;IAEI,SAAS;IACT;AACJ;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,oQAAoQ;EACpQ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,oKAAoK;EACpK,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB;AACF;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;;IAEI,UAAU;IACV,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,oBAAoB;IACpB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,oQAAoQ;IACpQ,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,oKAAoK;IACpK,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,OAAO;IACP,eAAe;EACjB;;EAEA;;IAEE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,wBAAwB;EAC1B;;EAEA;;IAEE,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;EACF;;EAEA;;IAEE,mBAAmB;EACrB;;CAED;EACC,YAAY;EACZ,UAAU;EACV,WAAW;;CAEZ;CACA;CACA,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,iBAAiB;CACjB,eAAe;CACf,eAAe;CACf;CACA;EACC,eAAe;CAChB;CACA;EACC,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;;EAErB;EACA;EACA,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,MAAM;EACN,WAAW;;EAEX;EACA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;EACA;;IAEE,mBAAmB;;;EAGrB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;;EAEnB;EACA;;IAEE,mBAAmB;EACrB;;;EAGA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;;EAEjB;EACA;;IAEE,mBAAmB;;;EAGrB;EACA;EACA,iBAAiB;EACjB,aAAa;EACb,gBAAgB;;EAEhB;EACA;IACE,iBAAiB;EACnB,aAAa;EACb;EACA;IACE,iBAAiB;EACnB,aAAa;EACb;EACA;EACA,aAAa;EACb,sBAAsB;EACtB,kBAAkB;;EAElB;EACA;EACA,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB;EACA;GACC,aAAa;GACb,gBAAgB;GAChB,aAAa;GACb,6BAA6B;EAC9B;;EAEA,gBAAgB;EAChB;IACE,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd","sourcesContent":[".sapmain\r\n{\r\n    height:100vh;\r\n    width:100%;\r\n    background-color: #000000;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n   \r\n    color:white;\r\n}\r\ntable {\r\n  margin-top: 10px ;\r\n  width: 100%;\r\n  height:150px;\r\n  border-collapse: collapse;\r\n}\r\nth, td {\r\n  padding: 8px;\r\n  text-align: left;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\ntr.violated {\r\n  background-color: #eb9c9c;\r\n}\r\nh2, h3 {\r\n  color: #333;\r\n}\r\n.button {\r\n  background-color: #4CAF50; /* Green */\r\n  border: none;\r\n  color: white;\r\n  padding: 10px 20px;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  font-size: 16px;\r\n  margin: 4px 2px;\r\n  cursor: pointer;\r\n}\r\n.sapcard\r\n{\r\n    height:70%;\r\n    width:40%;\r\n    background-color: white;\r\n    border: 1px solid black;\r\n    display: flex;\r\n    flex-direction: column;\r\n    border-radius: 10px;\r\n    color: black;\r\n\r\n    margin: auto;\r\n    justify-content: center;\r\n}\r\n.pref_card{\r\n  position: absolute;\r\n  width: 200px;\r\n  height: 200px;\r\n  background-color: white;\r\n  border-radius: 10px;\r\n  color:black;\r\n\r\n  margin:20px;\r\n}\r\n.pref_text{\r\n  padding: 2px;\r\n}\r\n.navbar1\r\n{\r\n    width:200px;\r\n    height:8%;\r\n    padding: 20px;\r\n    margin-left: 40px;\r\n    display: flex;\r\n    align-items: center;\r\n    cursor: pointer;\r\n     \r\n    /* background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); */\r\n}\r\n\r\n.result_modal{\r\n  position: fixed;\r\n  top:0;\r\n  left:0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background: rgba(0, 0, 0, 0.5);\r\n}\r\n.modal-box{\r\n  background-color: #ffffff;\r\n  height: 508px;\r\n  width: 732px;\r\n  margin: auto;\r\n  padding: 10px;\r\n  box-shadow: 2px solid black;\r\n  border-radius: 6px;\r\n  color: black;\r\n}\r\n.download_btn{\r\n  background: transparent;\r\n  width:20px;\r\n  height: 20px;\r\n}\r\n.modal_text{\r\n  /* color: rgb(255, 255, 255); */\r\n  color: black;\r\n  padding: 13px;\r\n  font-size: 18px;\r\n  position: relative;\r\n  margin-left: 10px;\r\n  margin-top: 30px;\r\n}\r\n.close_btn{\r\n  position: absolute;\r\n  color: #f53535;\r\n  font-size: 28px;\r\n  cursor: pointer;\r\n}\r\n.navbar1:hover{\r\n  color: #642bff;\r\n}\r\n.home_link{\r\n  text-decoration: none;\r\n     color:white;\r\n     font-size: 18px;\r\n     margin-left: 4px;\r\n}\r\n.home_link:hover{\r\n  color:#642bff;\r\n\r\n}\r\n.sapcard div {\r\n    display: flex;\r\n   margin-bottom: 10px; /* Adding some space between each div */\r\n  }\r\n\r\n.APIIN\r\n{\r\n    width:50%;\r\n    height:30px;\r\n    padding-left: 10px;\r\n}\r\n.filein\r\n{\r\n    width:50%;\r\n    height:30px\r\n}\r\n\r\n.button-18 {\r\n  align-items: center;\r\n  background-color: #642bff;\r\n  border: 0;\r\n  border-radius: 100px;\r\n  box-sizing: border-box;\r\n  color: #ffffff;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  font-family: -apple-system, system-ui, system-ui, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Fira Sans\", Ubuntu, Oxygen, \"Oxygen Sans\", Cantarell, \"Droid Sans\", \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Lucida Grande\", Helvetica, Arial, sans-serif;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  justify-content: center;\r\n  line-height: 20px;\r\n  max-width: 250px;\r\n  min-height: 40px;\r\n  min-width: 0px;\r\n  overflow: hidden;\r\n  padding: 0px;\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n  text-align: center;\r\n  touch-action: manipulation;\r\n  transition: background-color 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s, box-shadow 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s, color 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s;\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  vertical-align: middle;\r\n  gap:8px\r\n}\r\n\r\n.button-18:hover { \r\n  background:transparent;\r\n  border: 2px solid #642bff;\r\n  color: black;\r\n}\r\n\r\n.button-18:active {\r\n  background: #09223b;\r\n  color: rgb(255, 255, 255, .7);\r\n}\r\n\r\n.button-18:disabled { \r\n  cursor: not-allowed;\r\n  background: rgba(0, 0, 0, .08);\r\n  color: rgba(0, 0, 0, .3);\r\n}\r\n.dimg\r\n{\r\n    width:20px;\r\n    height: 20px;\r\n}\r\n.button-19 {\r\n    align-items: center;\r\n    background-color: #BED754;\r\n    border: 0;\r\n    border-radius: 100px;\r\n    box-sizing: border-box;\r\n    color: #ffffff;\r\n    cursor: pointer;\r\n    display: inline-flex;\r\n    font-family: -apple-system, system-ui, system-ui, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Fira Sans\", Ubuntu, Oxygen, \"Oxygen Sans\", Cantarell, \"Droid Sans\", \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Lucida Grande\", Helvetica, Arial, sans-serif;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    justify-content: center;\r\n    line-height: 20px;\r\n    max-width: 250px;\r\n    min-height: 40px;\r\n    min-width: 0px;\r\n    overflow: hidden;\r\n    padding: 0px;\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n    text-align: center;\r\n    touch-action: manipulation;\r\n    transition: background-color 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s, box-shadow 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s, color 0.167s cubic-bezier(0.4, 0, 0.2, 1) 0s;\r\n    user-select: none;\r\n    -webkit-user-select: none;\r\n    vertical-align: middle;\r\n    gap:8px;\r\n    margin-top:20px;\r\n  }\r\n  \r\n  .button-19:hover,\r\n  .button-19:focus { \r\n    background-color: #8ADAB2;\r\n    color: #ffffff;\r\n  }\r\n  \r\n  .button-19:active {\r\n    background: #8ADAB2;\r\n    color: rgb(255, 255, 255, .7);\r\n  }\r\n  \r\n  .button-19:disabled { \r\n    cursor: not-allowed;\r\n    background: rgba(0, 0, 0, .08);\r\n    color: rgba(0, 0, 0, .3);\r\n  }\r\n\r\n  .ii1\r\n  {\r\n    width:100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap:10px\r\n  }\r\n\r\n  .sapnavbar\r\n  {\r\n    align-items: center;\r\n  }\r\n\r\n .sapcont{\r\n  display:flex;\r\n  width:100%;\r\n  height:100%;\r\n\r\n }\r\n .drawer-cont{\r\n position: absolute;\r\n right:0;\r\n top:10;\r\n margin-right:20px;\r\n font-size: 30px;\r\n cursor: pointer;\r\n }\r\n label{\r\n  font-size: 14px;\r\n }\r\n .drawer{\r\n  width: 17.2%;\r\n  height: 80vh;\r\n  background-color: #642bff;\r\n  position: absolute;\r\n  top: 10;\r\n  right: 0;\r\n  transition: all 0.5s ease-in-out;\r\n  margin-top: 30px;\r\n  border-radius: 6px ;\r\n  margin-right: 20px;\r\n  overflow-y: scroll;\r\n  scrollbar-width: thin;\r\n  \r\n  }\r\n  .close{\r\n  font-size: 30px;\r\n  background-color: #3743e6;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 150px;\r\n  \r\n  }\r\n  .submit_btn{\r\n    padding: 5px 16px;\r\n    background-color: #2ea44f;\r\n    border-radius: 2px ;\r\n    color: white;\r\n    border: none;\r\n    cursor: pointer;\r\n  }\r\n  .submit_btn:hover{\r\n   \r\n    background: #3f9b59;\r\n \r\n\r\n  }\r\n  .checkbox-dropdown > label{\r\n    padding: 4px;\r\n  }\r\n  .checkbox-dropdown > label > input{\r\n    margin-right: 5px;\r\n    \r\n  }\r\n  input[type=\"checkbox\"]{\r\n    \r\n    accent-color: black;\r\n  }\r\n\r\n   \r\n  .cancel_btn{\r\n    padding: 5px 16px;\r\n    background-color: #BF3131;\r\n    border: none;\r\n    color: white;\r\n    border-radius: 2px;\r\n    cursor: pointer;\r\n    \r\n  }\r\n  .cancel_btn:hover{\r\n    \r\n    background: #c54a4a;\r\n   \r\n\r\n  }\r\n  .dropdown1{\r\n  padding-top: 20px;\r\n  padding: 10px;\r\n  margin-top: 40px;\r\n  \r\n  }\r\n  .dropdown2{\r\n    padding-top: 20px;\r\n  padding: 10px;\r\n  }\r\n  .dropdown3{\r\n    padding-top: 20px;\r\n  padding: 10px;\r\n  }\r\n  .checkbox-dropdown{\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-left: 10px;\r\n \r\n  }\r\n  .dropdownArrow{\r\n  display: flex;\r\n  font-size: 30px;\r\n  align-items: center;\r\n  }\r\n  .actionbtns{\r\n   padding: 10px;\r\n   margin-top: 20px;\r\n   display: flex;\r\n   justify-content: space-evenly;\r\n  }\r\n\r\n  /*  search bar */\r\n  .search-box {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 100%;\r\n}\r\n\r\n.search-input {\r\n    width: 80%;\r\n    margin-left: 10px;\r\n    margin-top: 10px;\r\n    padding: 6px 20px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);\r\n    font-size: 16px;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.search-input:focus {\r\n    outline: none;\r\n    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.search-btn {\r\n    position: absolute;\r\n    top: 65%;\r\n    right:30px;\r\n    transform: translateY(-50%);\r\n    border: none;\r\n    background: none;\r\n    padding: 0;\r\n    cursor: pointer;\r\n}\r\n\r\n.search-icon {\r\n    width: 24px;\r\n    height: 24px;\r\n    fill: #555;\r\n    transition: fill 0.3s ease;\r\n}\r\n\r\n.search-btn:hover .search-icon {\r\n    fill: #333;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
